export default __webpack_public_path__ + "static/media/rectangle.96510110.svg";